async function compressImage(file) {
  return new Promise((resolve) => {
    if (!file.type.startsWith("image/")) {
      resolve(file);
      return;
    }

    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      const canvas = document.createElement("canvas");

      const maxWidth = 1200;
      const scale = Math.min(1, maxWidth / img.width);

      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          resolve(new File([blob], file.name, { type: "image/jpeg" }));
        },
        "image/jpeg",
        0.8
      );
    };

    reader.readAsDataURL(file);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var openBtn = document.getElementById("openCustomizer");
  var modal = document.getElementById("customModal");
  var closeBtn = document.getElementById("closeModal");
  var submitBtn = document.getElementById("submitCustom");
  var statusMsg = document.getElementById("statusMsg");
  var fileInput = document.getElementById("fileInput");
  var messageInput = document.getElementById("messageInput");
  var petNameInput = document.getElementById("petName");

  if (!openBtn || !modal || !closeBtn || !submitBtn || !statusMsg || !fileInput || !messageInput || !petNameInput) {
    console.error("Customizer elements missing");
    return;
  }

  openBtn.addEventListener("click", function () {
    modal.style.display = "block";
  });

  closeBtn.addEventListener("click", function () {
    modal.style.display = "none";
  });

  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });

  submitBtn.addEventListener("click", async function () {
    var file = fileInput.files[0];
    var message = messageInput.value || "";
    var petName = petNameInput.value || "";

    if (!file) {
      statusMsg.innerText = "Please select a file.";
      return;
    }

    statusMsg.innerText = "Uploading...";

    var previewWindow = window.open("", "_blank");

    if (previewWindow) {
      previewWindow.document.open();
      previewWindow.document.write(
        '<!DOCTYPE html><html><head><title>Preparing Preview</title></head>' +
        '<body style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:Arial,sans-serif;">' +
        '<p>Preparing your preview...</p></body></html>'
      );
      previewWindow.document.close();
    }
async function compressImage(file) {
  return new Promise((resolve) => {
    if (!file.type.startsWith("image/")) {
      resolve(file);
      return;
    }

    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      const canvas = document.createElement("canvas");

      const maxWidth = 1200;
      const scale = Math.min(1, maxWidth / img.width);

      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          resolve(new File([blob], file.name, { type: "image/jpeg" }));
        },
        "image/jpeg",
        0.8 // quality
      );
    };

    reader.readAsDataURL(file);
  });
}
    var formData = new FormData();
    const optimizedFile = await compressImage(file);
    formData.append("file", file);
    formData.append("message", message);
    formData.append("name", petName);

    try {
      var response = await fetch("https://ignite-api-1.onrender.com/upload", {
        method: "POST",
        body: formData
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || "Upload failed");
      }

      statusMsg.innerText = "Upload complete";

      setTimeout(function () {
        modal.style.display = "none";
      }, 1000);

      if (previewWindow && result.url) {
        previewWindow.location.href = result.url;
      } else if (result.url) {
        window.location.href = result.url;
      }

    } catch (err) {
      console.error(err);
      statusMsg.innerText = "Upload failed";
      if (previewWindow) previewWindow.close();
    }
  });
});